query homeNumberEditPage ($teamId: ID!) {

  students(teamId: $teamId) {
    id
    first
    last
    positivity
    mostRecentCommunication
    communicationCount
    gradeLevel {
      id
      name
      order
    }
  }

  homeLanguages {
    id
    language
    name
    order
  }

}
